export default __webpack_public_path__ + "static/media/checkGif.46868953.webp";